import { render, staticRenderFns } from "./FrameFoot.vue?vue&type=template&id=24e19ed8&scoped=true"
import script from "./FrameFoot.vue?vue&type=script&lang=js"
export * from "./FrameFoot.vue?vue&type=script&lang=js"
import style0 from "./FrameFoot.vue?vue&type=style&index=0&id=24e19ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e19ed8",
  null
  
)

export default component.exports